const baseRoutes = {
  login: `login`,
  register: `register`,
  schools: `schools`,
  dashboard: `dashboard`,
  reception: `reception`,
  admissionEnquiry: `admission-enquiry`,
  studentManagement: `student-management`,
  schoolManagement: `management`,
  fees_management: `fees_management`,
  task_management: `task-management`,
  ledger_and_account: `ledger-n-account`,
  firm_management: `firm-management`,
  examControl: `exam-control`,
  academics: `academics`,
  communication: `communication`,
  transportation: `transportation`,
  hr: "hr",
  validateSession: `validate-session`,
  bioMetric: "bio-metric",
  websiteBuilder: "website-builder",
  accessControl: "access-control",
  paymentGateway: "payment-gateway",
  library: `library`,

  // settings routes
  settings: `settings`,

  // help and support routes
  helpAndSupport: `help-and-support`,
  ticket: `ticket`,
};

const appRoutes = {
  login: baseRoutes.login,
  register: baseRoutes.register,
  forgotPassword: "/forgot-password",
  // passwordChange: "/password-change",
  schools: baseRoutes.schools,
  bioMetric: baseRoutes.bioMetric,
  paymentGateway: baseRoutes.paymentGateway,
  userProfile: "user-profile",
  applySchool: "apply-school",
  validateSession: baseRoutes.validateSession,

  // Dashboard
  dashboard: baseRoutes.dashboard,
  schoolDashboard: `${baseRoutes.dashboard}/school`,
  collegeDashboard: `${baseRoutes.dashboard}/college`,
  coachingDashboard: `${baseRoutes.dashboard}/coaching`,
  groupOfInstitutesDashboard: `${baseRoutes.dashboard}/group-of-institutes`,

  // Admission Enquiry
  admissionEnquiry: baseRoutes.admissionEnquiry,
  visuals: `${baseRoutes.admissionEnquiry}/visuals`,
  enquiry: `${baseRoutes.admissionEnquiry}/enquiry`,
  formFeeStructure: `${baseRoutes.admissionEnquiry}/formFeeStructure`,
  counselor: `${baseRoutes.admissionEnquiry}/counselor`,
  previousSchool: `${baseRoutes.admissionEnquiry}/previousSchool`,
  createNewStudent: `${baseRoutes.admissionEnquiry}/createNewStudent`,

  // Students Management
  studentManagement: baseRoutes.studentManagement,
  admissionApproval: `${baseRoutes.studentManagement}/admission-approval`,
  certificate: `${baseRoutes.studentManagement}/certificate`,
  students: `${baseRoutes.studentManagement}/students`,
  studentReport: `${baseRoutes.studentManagement}/student-report`,
  studentSR: `${baseRoutes.studentManagement}/student-sr`,
  bulkEdit: `${baseRoutes.studentManagement}/bulkEdit`,
  promotionAndMigration: `${baseRoutes.studentManagement}/promotionAndMigration`,
  create_student: `${baseRoutes.studentManagement}/students/create-student`,
  student_profile: `${baseRoutes.studentManagement}/students/student-profile`,
  alumni: `${baseRoutes.studentManagement}/alumni`,
  idCard: `${baseRoutes.studentManagement}/idCard`,
  existStudent: `${baseRoutes.studentManagement}/existStudent`,
  edit_promotion_student_details: `${baseRoutes.studentManagement}/promotionAndMigration/edit-details`,
  migrate: `${baseRoutes.studentManagement}/promotionAndMigration/migrate`,
  editMigrate: `${baseRoutes.studentManagement}/promotionAndMigration/edit-migration`,
  edit_admission_approval_details: `${baseRoutes.studentManagement}/admission-approval/edit-details/:requestDocId`,
  studentVisuals: `${baseRoutes.studentManagement}/visuals`,

  // Transportation
  transport: baseRoutes.transportation,
  transportDetail: `${baseRoutes.transportation}/transport-detail`,
  routeDetail: `${baseRoutes.transportation}/route-detail`,
  feeStructure: `${baseRoutes.transportation}/fee-structure`,
  transportStudent: `${baseRoutes.transportation}/transport-student`,
  updateTransportDetail: `${baseRoutes.transportation}/updateTransportDetail`,

  // Fees Management
  fees_management: baseRoutes.fees_management,
  fees: `${baseRoutes.fees_management}/fees-structure`,
  collectFee: `${baseRoutes.fees_management}/collect-fee`,
  fees_collection: `${baseRoutes.fees_management}/fees_collection`,
  fees_collection2: `${baseRoutes.fees_management}/new-fee-collection`,
  fees_report: `${baseRoutes.fees_management}/fees_report`,
  fees_invoice: `${baseRoutes.fees_management}/fees_invoice`,
  fees_discount: `${baseRoutes.fees_management}/fees_discount`,
  arrear: `${baseRoutes.fees_management}/arrear`,
  invoice: `${baseRoutes.fees_management}/invoice`,
  sessionOrderInvoice: `${baseRoutes.fees_management}/session-order-invoice`,
  NewInvoice: `${baseRoutes.fees_management}/new-invoice`,
  arrearInvoice: `${baseRoutes.fees_management}/arrear-invoice`,
  adhoc: `${baseRoutes.fees_management}/adhoc`,

  // Ledger and Account
  ledger_and_account: baseRoutes.ledger_and_account,
  collections: `${baseRoutes.ledger_and_account}/collections`,
  expenses: `${baseRoutes.ledger_and_account}/expenses`,
  cash_book: `${baseRoutes.ledger_and_account}/cash-book`,
  ledger_repport: `${baseRoutes.ledger_and_account}/ledger-report`,
  collectionSubHeads: `${baseRoutes.ledger_and_account}/ledger-report/sub-heads/c/:id`,
  expenseSubHeads: `${baseRoutes.ledger_and_account}/ledger-report/sub-heads/e/:id`,
  paySlip: `${baseRoutes.ledger_and_account}/books/pay-slip`,
  uniformPaySlip: `${baseRoutes.ledger_and_account}/uniform/pay-slip`,

  // Firm Management
  firm_management: baseRoutes.firm_management,
  firm: `${baseRoutes.firm_management}/firms`,
  firmProfile: `${baseRoutes.firm_management}/firm/profile`,
  books: `${baseRoutes.firm_management}/books`,
  uniform: `${baseRoutes.firm_management}/uniform`, // backward compatible
  uniform: `${baseRoutes.firm_management}/uniform`,
  firmInvoice: `${baseRoutes.firm_management}/firm-invoice`,

  // Academics
  academics: baseRoutes.academics,
  homework: `${baseRoutes.academics}/homework`,
  attendanceAndLeave: `${baseRoutes.academics}/attendance-and-leave`,
  timeTable: `${baseRoutes.academics}/timetable`,
  syllabus: `${baseRoutes.academics}/syllabus`,
  subject_details: `${baseRoutes.academics}/syllabus/subject-details`,
  academicCalendar: `${baseRoutes.academics}/academic-calendar`,

  // Exam Control
  examControl: baseRoutes.examControl,
  testsAndExams: `${baseRoutes.examControl}/tests-and-exams`,
  reportCard: `${baseRoutes.examControl}/report-card`,
  admitCard: `${baseRoutes.examControl}/admit-card`,
  printAdmitCard: `${baseRoutes.examControl}/admit-card/printAdmitCard`,

  // Library
  library: baseRoutes.library,

  // Reception
  reception: baseRoutes.reception,
  complaints: `${baseRoutes.reception}/complaints`,
  visitorControl: `${baseRoutes.reception}/visitor-control`,
  staffAttendance: `${baseRoutes.reception}/staff-attendance`,
  admission_enquiry: `${baseRoutes.reception}/admission-enquiry`,
  complaintDetails: `${baseRoutes.reception}/complaint/:complaintId`,

  // Human Resources
  hr: baseRoutes.hr,
  staffManagement: `${baseRoutes.hr}/staff-management`,
  joiningApproval: `${baseRoutes.hr}/joining-approval`,
  staffProfile: `${baseRoutes.hr}/staff-management/staff-profile`,
  newRegistration: `${baseRoutes.hr}/staff-management/newRegistration`,
  staffLeave: `${baseRoutes.hr}/staff-leave`,
  payroll: `${baseRoutes.hr}/payroll`,
  createPayroll: `${baseRoutes.hr}/payroll/create`,
  printSlip: `${baseRoutes.hr}/payroll/print-slip`,

  // Communication
  communication: baseRoutes.communication,
  noticeBoard: `${baseRoutes.communication}/notice-board`,
  textSms: `${baseRoutes.communication}/text-sms`,
  whatsApp: `${baseRoutes.communication}/whatsapp`,
  vlwhatsapp: `${baseRoutes.communication}/vlwhatsapp`,

  // School Management
  schoolManagement: baseRoutes.schoolManagement,
  sessionSettings: `${baseRoutes.schoolManagement}/session-settings`,
  departments: `${baseRoutes.schoolManagement}/departments`,
  classes: `${baseRoutes.schoolManagement}/classes`,
  // invitationCode: `${baseRoutes.schoolManagement}/invitation-code`,
  billsUsage: `${baseRoutes.schoolManagement}/bills-usage`,
  storage: `${baseRoutes.schoolManagement}/storage`,

  // Task Management
  task_management: baseRoutes.task_management,
  tasks: `${baseRoutes.task_management}/tasks`,
  taskReport: `${baseRoutes.task_management}/task-report`,

  // Access Control
  accessControl: baseRoutes.accessControl,
  permission: `${baseRoutes.accessControl}/permission`,
  authorizedPerson: `${baseRoutes.accessControl}/authorized-person`,
  sessionOrders: `${baseRoutes.accessControl}/session-orders`,

  // Bio-Metric
  punchLog: `${baseRoutes.bioMetric}/punch-log`,
  deviceDetail: `${baseRoutes.bioMetric}/device-detail`,
  userDetail: `${baseRoutes.bioMetric}/user-detail`,

  // Website Builder
  websiteBuilder: baseRoutes.websiteBuilder,
  themePage: `${baseRoutes.websiteBuilder}/theme-page`,
  schoolInformation: `${baseRoutes.websiteBuilder}/school-information`,
  homePage: `${baseRoutes.websiteBuilder}/home`,
  galleryAndLinks: `${baseRoutes.websiteBuilder}/gallery-and-links`,
  aboutUs: `${baseRoutes.websiteBuilder}/about-us`,
  academic: `${baseRoutes.websiteBuilder}/academic`,
  achievementsHub: `${baseRoutes.websiteBuilder}/achievements-hub`,

  orders: `${baseRoutes.paymentGateway}/orders`,
  configuration: `${baseRoutes.paymentGateway}/configuration`,
  razorpayCallback: `${baseRoutes.paymentGateway}/razorpay-callback`,

  // About School
  aboutSchool: `${baseRoutes.schools}/about-school`,
  schoolProfile: `${baseRoutes.schools}/school-profile`,

  // Settings
  settings: baseRoutes.settings,

  // Ekalsutra Policy
  privacyPolicy: "/schools/privacy-policy",
  termsAndConditions: "/schools/terms-and-conditions",
  refundPolicy: "/schools/refund-policy",

  // Help And Support
  helpAndSupport: `${baseRoutes.helpAndSupport}`,
  ticketDetails: `${baseRoutes.helpAndSupport}/ticket/:ticketId`,
};

export default appRoutes;
